module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-box",
    class: {
      'download-header': _vm.isdownload
    }
  }, [_c('main-header-pc', {
    class: [
      'pc-show',
      {
        'transparent-theme': _vm.specialHeader
      } ]
  }), _vm._v(" "), _c('main-header-phone', {
    class: [
      'phone-show',
      {
        'transparent-theme': _vm.specialHeader
      } ]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03a88998!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plexHeader/mainHeader/Index.vue
// module id = 1255
// module chunks = 1